<div class="titulo" [ngClass]="{'type-b': templateSuffix !== ''}">
  <strong> {{ title }} </strong>
</div>
<ol class="subtitulos"  [ngClass]="{'type-b': templateSuffix !== ''}" *ngIf="title1 && title2">
  <li>
    <strong>{{ title1 }}</strong>
  </li>
  <li>
    <strong>{{ title2 }}</strong>
  </li>
</ol>
